import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared/shared.module';
import { AppDefaultComponent } from './app-default/app-default.component';
import { HeaderComponent } from 'src/app/@layout/header/header.component';
import { ModalPerfilComponent } from 'src/app/@layout/header/modal-perfil/modal-perfil.component';
import { ModalSugestoesComponent } from 'src/app/@layout/header/modal-sugestoes/modal-sugestoes.component';
import { ModalAlertaComponent } from 'src/app/@layout/header/modal-alerta/modal-alerta.component';
import { ComponentsModule } from 'src/app/@shared/components/components.module';
import { ModalPesquisaMenuComponent } from 'src/app/@layout/header/modal-pesquisa-menu/modal-pesquisa-menu.component';

@NgModule({
  declarations: [
    AppDefaultComponent,
    HeaderComponent,
    ModalPerfilComponent,
    ModalSugestoesComponent,
    ModalAlertaComponent,
    ModalPesquisaMenuComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule
  ],
  exports: [
    AppDefaultComponent,
    HeaderComponent,
    ModalPerfilComponent,
    ModalSugestoesComponent,
    ModalAlertaComponent,
    ModalPesquisaMenuComponent
  ]})

export class AppDefaultModule {}
